<template>
  <div class="container">
    <div class="navbar">
      <img src="../../../static/images/back.png" @click="back" />
      <div>做题记学时</div>
      <div style="width: 1rem"></div>
    </div>
    <div class="header">
      <div class="header-tit">累计学习</div>
      <div class="header-time">
        <div class="hours">00</div>
        :
        <div class="minutes">00</div>
        :
        <div class="seconds">00</div>
      </div>
    </div>
    <!-- 服务说明 -->
    <div class="neck" v-if="flag">
      <div class="neck-tit">服务说明</div>
      <div class="neck-item">
        <span>1</span>
        <div>以下服务，“做题记学时”总学时2小时。</div>
      </div>
      <div class="neck-item">
        <span>2</span>
        <div>结束学习，请点击“签退”并进行验证，否则不记入学时。</div>
      </div>
      <div class="neck-item">
        <span>3</span>
        <div>单次练习不低于15分钟，否则不计入学时。</div>
      </div>
      <div class="neck-item">
        <span>4</span>
        <div>联系期间每隔15分钟需本人进行人脸识别确认。</div>
      </div>
    </div>
    <!-- 理论记学时 -->
    <div class="neck" v-if="flag">
      <div class="neck-tit">理论记学时</div>
      <div class="footer-item">
        <div class="left">
          <img src="../../../static/images/shunxu.png" alt="" />
          <div class="text">
            <span>顺序练习记学时</span>
            <p>按知识点练习全部题目</p>
          </div>
        </div>
        <div class="right" @click="gotopage">去练习</div>
      </div>
      <div class="footer-item">
        <div class="left">
          <img src="../../../static/images/naozhong.png" alt="" />
          <div class="text">
            <span>模拟考试记学时</span>
            <p>模拟理论考试进行训练</p>
          </div>
        </div>
        <div class="right" @click="gotomonikaoshipage">去考试</div>
      </div>
    </div>
    <!-- 学时已修满 -->
    <div class="main" v-if="!flag">
      <div class="taken colorYellow">
        <div>恭喜您</div>
        <div>做题计时已修满</div>
      </div>
      <div class="taken">
        <div>巩固学习</div>
        <p>学堂君提示您继续巩固学习，更易通过考试！</p>
      </div>
      <div class="footer-item">
        <div class="left">
          <img src="../../../static/images/huosu.png" alt="" />
          <div class="text">
            <span>新规练习</span>
            <p>新规习题专项练习</p>
          </div>
        </div>
        <div class="right">去练习</div>
      </div>
      <div class="footer-item">
        <div class="left">
          <img src="../../../static/images/shunxu.png" alt="" />
          <div class="text">
            <span>顺序练习</span>
            <p>按知识点练习全部题目</p>
          </div>
        </div>
        <div class="right">去练习</div>
      </div>
      <div class="footer-img">
        <div>更多服务推荐</div>
        <img src="../../../static/images/juxing1.png" alt="" />
        <img src="../../../static/images/juxing2.png" alt="" />
        <img src="../../../static/images/juxing3.png" alt="" />
        <img src="../../../static/images/juxing4.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "remenberHours",
  data() {
    return {
      flag: true,
      // 科目1 科目4
      showType: 1,
    };
  },
  created() {
    document.documentElement.style.fontSize = "625%";
    // console.log(this.param.licence_id);
    var info = localStorage.getItem("ke1total");
    if (info) {
      this.$data.ke1 = info;
    } else {
      this.getInfoMsg(1);
    }
    var info4 = localStorage.getItem("ke4total");
    if (info4) {
      this.$data.ke4 = info4;
    } else {
      this.getInfoMsg(4);
    }
    console.log = function () {
    };
  },
  mounted() {
    // ---------------禁止拖拽返回-----------------
    // 如果支持 popstate （一般移动端都支持）
    if (window.history && window.history.pushState) {
      // 往历史记录里面添加一条新的当前页面的url
      history.pushState(null, null, document.URL);
      // 给 popstate 绑定一个方法 监听页面刷新
      window.addEventListener("popstate", this.backNative, false); //false阻止默认事件
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.backNative, false); //false阻止默认事件
  },

  methods: {
    // 返回上一层
    back() {
      // this.$router.go(-1); //返回上一层
      //  this.$router.push({
      //     name: "home",
      //   });
      window.location.href = "backtonative.html"; //返回操作
    },

    // 顺序练习
    gotopage() {
      // https://tiku.chexuetang.cn/index
      // cx=xc&km=kmy&userid=0211a9f1c5c5059eae6cbb37c5468c21&appid=123456&os=&appver=1.0&channel=exejH5&coachid=0&schoolid=16765&timestamp=1658987651&sign=ffa8b06edd325245bf2ab07ef8b64072
      this.$router.push({
        name: "sxlx",
        query: {
          cx: "xc",
          km: "km",
          userid: "0211a9f1c5c5059eae6cbb37c5468c21",
          appid: 123456,
          os: "",
          appver: "1.0",
          channel: "exejH5",
          coachid: 0,
          schoolid: 16765,
          timestamp: 1658987651,
          sign: "ffa8b06edd325245bf2ab07ef8b64072",
        },
      });
    },
    // 模拟考试
    gotomonikaoshipage() {
      // cx=xc&km=kmy&userid=d52c89899cc00d740f7008ad29baec7d&appid=123456&os=&appver=1.0&channel=exejH5&coachid=0&schoolid=16765&timestamp=1658989311&sign=f4a563daab3f438aabe7fcdc0e7a0b87
      let xc = 2; // 小车
      this.$router.push({
        name: "exam",
        query: {
          cx: 2,
          km: "km",
          userid: "0211a9f1c5c5059eae6cbb37c5468c21",
          appid: 123456,
          os: "",
          appver: "1.0",
          channel: "exejH5",
          coachid: 0,
          schoolid: 16765,
          timestamp: 1658987651,
          sign: "ffa8b06edd325245bf2ab07ef8b64072",
        },
      });
    },
    goIndex() {
      window.location.href = "backtonative.html";
    },
    backNative() {
      console.log("监听到了");
      //点击物理返回键要执行的操作
      window.location.href = "backtonative.html";
    },
    // ---------------禁止拖拽返回-------------------
    getInfoMsg(type) {
      console.log(type);
    },
    changekemu(index) {
      this.$data.showType = index;
    },
  },
  afterDestory() {
    document.documentElement.style.fontSize = "";
  }
};
</script>
<style lang="scss" scoped>
html {
  background-color: #fff;
}
.container {
  width: 100%;
  font-size: 0.18rem;
  // 顶部导航
  .navbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 4rem;
    padding: 1rem 1rem 0;
    background: rgb(85, 169, 225);
    img {
      width: 1rem;
      height: 1rem;
    }
  }
  // 顶部累计学时
  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;
    height: 9rem;
    width: 100%;
    background-image: url("../../../static/images/header.png");
    background-size: 100% 100%;
    color: #fff;
    .header-tit {
      margin-bottom: 1rem;
      width: 7.4rem;
      height: 1.6rem;
      text-align: center;
      font-size: 1.2rem;
      background: #333;
      border-radius: 1rem;
    }
    .header-time {
      display: flex;
      font-size: 2.5rem;
      line-height: 3rem;
      text-align: center;
      color: #333;
      div {
        margin: 0 1rem;
        width: 3rem;
        height: 3rem;
        border-radius: 0.5rem;
        background: #333;
        color: #fff;
      }
    }
  }
  // 服务说明
  .neck {
    padding: 1rem;
    font-size: 1rem;
    color: #333;
    .neck-tit {
      font-size: 1.2rem;
      font-weight: 600;
      margin-bottom: 1rem;
      text-align: center;
    }
    .neck-item {
      display: flex;
      margin-bottom: 1rem;
      line-height: 1.5rem;
      span {
        margin-right: 1rem;
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 1.5rem;
        color: #fff;
        text-align: center;
        background: rgb(88, 193, 246);
      }
    }
  }
  //   底部理论记学时
  .footer-item {
    display: flex;
    justify-content: space-between;
    border-bottom: 0.1rem solid #ddd;
    margin-top: 1rem;
    padding-bottom: 1rem;
    align-items: center;
    .left {
      display: flex;
      align-items: center;
      img {
        width: 2.5rem;
        margin-left: 1rem;
        margin-right: 2rem;
      }
      .text {
        margin-top: 0.8rem;
        font-size: 0.8rem;
        font-weight: 300;
        span {
          font-size: 1.2rem;
          font-weight: 500;
        }
      }
    }
    .right {
      width: 6rem;
      height: 2.5rem;
      border-radius: 2rem;
      line-height: 2.5rem;
      font-size: 1.2rem;
      text-align: center;
      color: #fff;
      background: rgb(255, 152, 2);
    }
  }
  // 学时已修满
  .main {
    padding: 0 0.7rem;
  }
  .taken {
    height: 6rem;
    margin: 0 auto;
    margin-top: 1rem;
    padding: 0 1.2rem;
    font-size: 1.5rem;
    font-weight: 600;
    text-align: center;
    p {
      font-size: 1rem;
      font-weight: 300;
    }
  }
  // 底部图片
  .footer-img {
    margin-top: 1rem;
    font-size: 1.5rem;
    font-weight: 600;
    div {
      margin-bottom: 1rem;
    }
    img {
      width: 25%;
    }
  }
  .colorYellow {
    color: rgb(255, 172, 47);
    border-bottom: 0.1rem solid #ddd;
  }
}
</style>